import type { ScraperParameterDefinition } from "../api/cityConfig";

export function initialScraperParameters(
  definitions: ScraperParameterDefinition[],
  current: Record<string, unknown> = {},
): Record<string, unknown> {
  return Object.fromEntries(
    definitions.map((definition) => [
      definition.key,
      current[definition.key] ??
        definition.default ??
        (definition.type === "boolean" ? false : ""),
    ]),
  );
}
